import { render, staticRenderFns } from "./BTableButtonExpand.vue?vue&type=template&id=564f1e4a&"
import script from "./BTableButtonExpand.vue?vue&type=script&lang=js&"
export * from "./BTableButtonExpand.vue?vue&type=script&lang=js&"
import style0 from "./BTableButtonExpand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports